import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getAccountSelected } from 'src/app/core/state/auth-state/auth.selectors';
import { getApiUrl } from 'src/app/core/state/general-state/general.selectors';
import { UserAccountInfo } from 'src/app/models/user-account/account-data';

@Injectable({
  providedIn: 'root'
})
export class BankingService {

  uri: string = '';
  account: UserAccountInfo | null = null;

  constructor(
    private http: HttpClient,
    private store: Store
  ) {
    this.store.select(getApiUrl).subscribe(apiUrl => this.uri = apiUrl);
    this.store.select(getAccountSelected).subscribe(account => this.account = account)
  }

  getBankingAccount(): Observable<any> {
    let params = new HttpParams()
      .set('accountIndex', this.account?.accountIndex ?? "")
    return this.http.get<any>(this.uri + '/v1/diletta/banking', { params });
  }

  getAccounts(): Observable<UserAccountInfo[]> {
    return this.http.get<any>(this.uri + '/v2/diletta/banking');
  }

  getBankingAccountBalance(): Observable<any> {
    // let params;
    // if (this.account !== null && this.account.accountIndex) {
    //   params = new HttpParams()
    //   .set('accountIndex', this.account?.accountIndex ?? "")
    // }

    const url = this.uri + '/v1/diletta/banking/balance';

    return this.http.get<any>(url);
  }

  getBankingCollection(start?: string, ending?: string, accountIndex?: string): Observable<any> {
    let params;

    if (start && ending)
      params = new HttpParams()
        .set('start', start)
        .set('ending', ending)

    // if (accountIndex)
    //   params = new HttpParams()
    //     .set('accountIndex', this.account?.accountIndex ?? "")

    return this.http.get<any>(this.uri + '/v1/diletta/collection/balance', { params: params });
  }

  getStatement(start?: string, ending?: string): Observable<any> {
    let params;

    if (start && ending)
      params = new HttpParams()
        .set('start', start)
        .set('ending', ending)

    return this.http.get(this.uri + '/v1/diletta/banking/statement', { params: params });
  }

  redirect(): Observable<any> {
    const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdXRoIjoiUk9MRV9VTkRFRklORUQiLCJzdWIiOiJlM2RiM2RmNS0xMzAwLTQwYWQtOGY3My02Yzk1NDgxYmYwMzEiLCJpYXQiOjE2OTUwNjM2ODgsIm5iZiI6MTY5NTA2MzY4OCwiZXhwIjoxNjk1MDY3Mjg4fQ.BaIp0r_b2UBPUQEb7C-Ayvsidq3fzboYwmj4xYSIKqU';
    return this.http.post('https://asainvestments.absportfolio.com.br/cliente/visao-resumida', { token });
  }

  setDisplayName(accountIndex: string, displayName: string): Observable<any> {
    const params = new HttpParams().set('accountIndex', accountIndex);
  
    const body = {
      displayName: displayName
    };
  
    return this.http.post(`${this.uri}/v1/diletta/banking/set-display-name`, body, { params });
  }
}
